import React from "react"
import InputMask from "react-input-mask"

import DatePicker, { registerLocale } from "react-datepicker"
import fr from "date-fns/locale/fr"
import moment from "moment"

registerLocale("fr", fr)

type Props = {
     name: string
     minDate?: string | undefined | null
     maxDate?: string | undefined | null
     value: string | undefined | null
     placeholder: string
     onChange: (value: any) => void
     autofocus?: boolean
}

const MyDateDayMonthYearField: React.FC<Props> = ({ name, value, onChange, placeholder, minDate, maxDate, autofocus = false }) => {
     return (
          <DatePicker
               dateFormat="dd/MM/yyyy"
               locale="fr"
               placeholderText={placeholder}
               customInput={
                    <InputMask className={"form-control"} mask="99/99/9999">
                         {() => <input type="text" inputMode={"numeric"} className={"form-control"} placeholder={placeholder} autoFocus={autofocus} />}
                    </InputMask>
               }
               name={name}
               minDate={minDate ? moment(minDate, "DD/MM/YYYY").toDate() : null}
               maxDate={maxDate ? moment(maxDate, "DD/MM/YYYY").toDate() : null}
               isClearable
               selected={value ? moment(value, "DD/MM/YYYY").toDate() : null}
               onChange={val => {
                    if (val) {
                         const d = moment(val).format("DD/MM/YYYY")
                         onChange(d)
                    } else {
                         onChange("")
                    }
               }}
          />
     )
}

export default MyDateDayMonthYearField
